enum PublicRoutes {
  ADMIN_LANDING = '/cheese/landing',
  ADMIN_LOGIN = '/cheese/login',
  ADMIN_REGISTER = '/cheese/register',
  LANDING = '/',
  LOGIN = '/login',
  LOGIN_EXPIRED = '/login/expired',
  REGISTRATION = '/register',
  REGISTRATION_FROM_INVITE = '/register/invite',
  REGISTRATION_INVITE_VERIFICATION_ERROR = '/register/invite-verification-error',
  REGISTRATION_SUCCESS = '/register/success',
  REGISTRATION_VERIFICATION_ERROR = '/register/verification-error',
  RESET_PASSWORD = '/reset-password',
  RESET_PASSWORD_REQUEST_SUCCESS = '/reset-password/success',
  RESET_PASSWORD_SET_PASSWORD = '/reset-password/submit',
  RESET_PASSWORD_SET_PASSWORD_SUCCESS = '/reset-password/submit/success',
  VERIFICATION = '/login/verification',
  VERIFICATION_ERROR = '/login/verification-error',
}

export default PublicRoutes;
